// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__RaGLB","hiddenOverlay":"overlay_hiddenOverlay__Nxw5T","overlayContent":"overlay_overlayContent__X8Gta"};